
import { defineComponent, computed } from 'vue'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faVuejs } from '@fortawesome/free-brands-svg-icons'
import router from '@/router'

export default defineComponent({
  props: {
    isThemeChanged: Boolean,
    isCollapsed: Boolean,
    isOpenExplorer: Boolean
  },
  setup (_, { emit }) {
    const currentPage = computed(() => router.currentRoute.value.name)

    const icons = computed(() => ({
      faVuejs,
      faTimes
    }))

    const collapseParts = () => emit('collapse-parts')
    const closeEditor = () => emit('close-editor')

    return {
      currentPage,
      icons,
      collapseParts,
      closeEditor
    }
  }
})
